import posthog from "posthog-js";

// Write-only project API key — safe to ship in the client bundle.
export const POSTHOG_KEY = "phc_Ccanb3qPhDVWoG2QQdEvDHBvfAy9ceTgAtjugHPx6UEt";
// Events are sent through our own reverse proxy to avoid ad blockers. The proxy
// forwards to PostHog's EU ingestion endpoint (https://eu.i.posthog.com).
export const POSTHOG_HOST = "https://b.bawo.app";
// The PostHog instance is hosted in the EU region. ui_host keeps the toolbar
// and in-app links pointing at the real UI even though ingestion is proxied.
export const POSTHOG_UI_HOST = "https://eu.posthog.com";

let initialised = false;

/**
 * Initialise PostHog analytics. Safe to call multiple times — only the first
 * call takes effect. Skipped under test and in non-browser environments.
 */
export function initialisePostHog() {
  if (initialised) return posthog;
  if (typeof window === "undefined") return posthog;
  if (process.env.NODE_ENV === "test") return posthog;

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    ui_host: POSTHOG_UI_HOST,
    // @reach/router drives client-side navigation via the History API, so
    // "history_change" auto-captures a $pageview on every route change (not
    // just full page loads), and capture_pageleave pairs a $pageleave with it.
    capture_pageview: "history_change",
    capture_pageleave: "if_capture_pageview",
    person_profiles: "always"
  });
  initialised = true;
  return posthog;
}

export { posthog };
